<template>
  <div ref="sidebar" class="sidebar sidebar-container">
    <div class="menu-items">
      <!--      头像-->
      <el-dropdown class="avatar-container" trigger="click" @click.native="showGropdown()">
        <div class="avatar">
          <img :src="imgSrc" alt="头像" style="object-fit: cover" @mouseenter="onMousedownHeader" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <el-dropdown-item :disabled="true">
            <div class="userInfo" @click.stop>
              <img :src="imgSrc" alt="" style="object-fit: cover; cursor: pointer" @click.stop="showBigImgSrc(imgSrc)" />
              <div class="userInfo-right">
                <div class="username">{{ userInfo.userName }}</div>
                <div class="company">{{ (userInfo.organizationPath || "").split(">")[0] }}</div>
              </div>
            </div>
          </el-dropdown-item>
          <!-- <el-dropdown-item @click.native="resetPsw">
            <span style="display: block">修改密码</span>
          </el-dropdown-item> -->
          <el-dropdown-item @click.native="openSetting">
            <span style="display: block">设置</span>
          </el-dropdown-item>
          <el-dropdown-item @click.native="logout">
            <span style="display: block">退出登录</span>
          </el-dropdown-item>
          <el-dropdown-item v-if="inTest" @click.native="lookComponents">
            <span style="display: block">查看组件</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div v-if="showGropdownStatus" class="dropdown_bg" @click="showGropdownStatus = false"></div>
      <!--      <div class="user-name">{{ userInfo.userName }}</div>-->
      <!--      收藏菜单-->
      <sidebar-item
        v-if="newFavoriteMenus()"
        :key="999"
        :item="newFavoriteMenus()"
        :menu-top-displayed="menuTopDisplayed"
        :menu-pop-up-method="menuPopUpMethod"
      ></sidebar-item>
      <!--      系统菜单-->
      <sidebar-item
        v-for="item in routes"
        :key="item.id"
        :item="item"
        :menu-top-displayed="menuTopDisplayed"
        :menu-pop-up-method="menuPopUpMethod"
      ></sidebar-item>
    </div>
    <SettingModal
      v-show="showSettingModal"
      id="settingModal"
      ref="settingModal"
      @changeHeaderImage="changeHeaderImage"
      @cancel="cancelSettingModal"
    />
    <!-- 系统通知 -->
    <SysNotify />

    <!-- 导入导出通知 -->
    <ImportExportNotify />
  </div>
</template>

<script>
import SidebarItem from "./SidebarItem/index.vue"
import { mapState } from "vuex"
import SettingModal from "./components/SettingModal.vue"
import SysNotify from "@/layout/components/SysNotify/index.vue"
import ImportExportNotify from "@/layout/components/importExportNotify/index.vue"

import { apiStaffGetStaffInfo, apiUserGeneralSettingsFind } from "@/api/user"
import { MICRO_APPS } from "@/micro/config"
// const defaultImg = "https://tfmall-test.oss-cn-shenzhen.aliyuncs.com/storage/images/image/tanfeizanweitu/8220359a06bb5a34a114a54d74a9b9e3.png"
const defaultImgNew = "https://test-static.tfeimall.com/src/menu/menuIcon_8043f5dd-430e-47c8-874e-6342e0230fce_1723713852035.png"
export default {
  components: { SidebarItem, SettingModal, SysNotify, ImportExportNotify },
  data() {
    return {
      imgSrc: defaultImgNew,
      showGropdownStatus: false,
      menuData: [
        {
          createTime: "2024-07-27 14:08:54",
          updateTime: "2024-07-27 14:08:54",
          creator: "太阳",
          updateBy: "",
          isDel: false,
          id: 155,
          parentId: 0,
          name: "营销中台",
          abbrName: "营销",
          icon: "https://test-static.tfeimall.com/src/menu/menuIcon_1fbdd90f-9bdb-4fb5-8c3e-200927fb9b4a_1722060514262.png",
          url: "",
          perms: "",
          type: 1,
          orderNum: 0,
          isShow: true,
          isSepaLine: false,
          list: [
            {
              createTime: "2024-07-27 14:09:44",
              updateTime: "2024-07-27 14:09:44",
              creator: "太阳",
              updateBy: "",
              isDel: false,
              id: 156,
              parentId: 155,
              name: "WCT",
              abbrName: "",
              icon: "",
              url: "/userData",
              perms: "",
              type: 1,
              orderNum: 0,
              isShow: true,
              isSepaLine: false,
              list: [
                {
                  createTime: "2024-07-27 14:10:06",
                  updateTime: "2024-07-27 14:10:06",
                  creator: "太阳",
                  updateBy: "",
                  isDel: false,
                  id: 157,
                  parentId: 156,
                  name: "微营销会话",
                  abbrName: "",
                  icon: "",
                  url: "/userData/wxChat",
                  perms: "",
                  type: 1,
                  orderNum: 0,
                  isShow: true,
                  isSepaLine: false,
                  isAdmin: 0
                },
                {
                  createTime: "2024-07-27 14:10:31",
                  updateTime: "2024-07-27 14:10:31",
                  creator: "太阳",
                  updateBy: "",
                  isDel: false,
                  id: 158,
                  parentId: 156,
                  name: "数据看板",
                  abbrName: "",
                  icon: "",
                  url: "/userData/marketPage",
                  perms: "",
                  type: 1,
                  orderNum: 0,
                  isShow: true,
                  isSepaLine: false,
                  isAdmin: 0
                },
                {
                  createTime: "2024-07-27 14:10:48",
                  updateTime: "2024-07-27 14:10:48",
                  creator: "太阳",
                  updateBy: "",
                  isDel: false,
                  id: 159,
                  parentId: 156,
                  name: "历史消息",
                  abbrName: "",
                  icon: "",
                  url: "/userData/historyMsg",
                  perms: "",
                  type: 1,
                  orderNum: 0,
                  isShow: true,
                  isSepaLine: false,
                  isAdmin: 0
                },
                {
                  createTime: "2024-07-27 14:11:16",
                  updateTime: "2024-07-27 14:11:16",
                  creator: "太阳",
                  updateBy: "",
                  isDel: false,
                  id: 160,
                  parentId: 156,
                  name: "朋友圈",
                  abbrName: "",
                  icon: "",
                  url: "/userData/wechatMoments",
                  perms: "",
                  type: 1,
                  orderNum: 0,
                  isShow: true,
                  isSepaLine: false,
                  list: [
                    {
                      createTime: "2024-07-27 14:11:45",
                      updateTime: "2024-07-27 14:11:45",
                      creator: "太阳",
                      updateBy: "",
                      isDel: false,
                      id: 161,
                      parentId: 160,
                      name: "朋友圈发圈",
                      abbrName: "",
                      icon: "",
                      url: "/userData/wechatMoments/engineMoments",
                      perms: "",
                      type: 1,
                      orderNum: 0,
                      isShow: true,
                      isSepaLine: false,
                      isAdmin: 0
                    },
                    {
                      createTime: "2024-07-27 14:12:04",
                      updateTime: "2024-07-27 14:12:04",
                      creator: "太阳",
                      updateBy: "",
                      isDel: false,
                      id: 162,
                      parentId: 160,
                      name: "朋友圈评论",
                      abbrName: "",
                      icon: "",
                      url: "/userData/wechatMoments/commentMoments",
                      perms: "",
                      type: 1,
                      orderNum: 0,
                      isShow: true,
                      isSepaLine: false,
                      isAdmin: 0
                    }
                  ],
                  isAdmin: 0
                },
                {
                  createTime: "2024-07-27 14:12:29",
                  updateTime: "2024-07-27 14:12:29",
                  creator: "太阳",
                  updateBy: "",
                  isDel: false,
                  id: 163,
                  parentId: 156,
                  name: "消息群发",
                  abbrName: "",
                  icon: "",
                  url: "/userData/groupMsg",
                  perms: "",
                  type: 1,
                  orderNum: 0,
                  isShow: true,
                  isSepaLine: false,
                  isAdmin: 0
                }
              ],
              isAdmin: 0
            },
            {
              createTime: "2024-07-27 14:12:58",
              updateTime: "2024-07-27 14:12:58",
              creator: "太阳",
              updateBy: "",
              isDel: false,
              id: 164,
              parentId: 155,
              name: "CDP",
              abbrName: "",
              icon: "",
              url: "/cdp",
              perms: "",
              type: 1,
              orderNum: 0,
              isShow: true,
              isSepaLine: false,
              list: [
                {
                  createTime: "2024-07-27 14:13:19",
                  updateTime: "2024-07-27 14:13:19",
                  creator: "太阳",
                  updateBy: "",
                  isDel: false,
                  id: 165,
                  parentId: 164,
                  name: "会员中心",
                  abbrName: "",
                  icon: "",
                  url: "/cdp/userCenter/index",
                  perms: "",
                  type: 1,
                  orderNum: 0,
                  isShow: true,
                  isSepaLine: false,
                  isAdmin: 0
                }
              ],
              isAdmin: 0
            }
          ],
          isAdmin: 0
        },
        {
          createTime: "2024-07-27 14:14:29",
          updateTime: "2024-07-27 14:14:29",
          creator: "太阳",
          updateBy: "",
          isDel: false,
          id: 166,
          parentId: 0,
          name: "产品中台",
          abbrName: "产品",
          icon: "https://test-static.tfeimall.com/src/menu/menuIcon_bd2ade27-3574-4172-9a6f-af3e3acd55b0_1722060867072.png",
          url: "",
          perms: "",
          type: 1,
          orderNum: 0,
          isShow: true,
          isSepaLine: false,
          list: [
            {
              createTime: "2024-07-27 14:14:53",
              updateTime: "2024-07-27 14:14:53",
              creator: "太阳",
              updateBy: "",
              isDel: false,
              id: 167,
              parentId: 166,
              name: "产品研发",
              abbrName: "",
              icon: "",
              url: "/plm",
              perms: "",
              type: 1,
              orderNum: 0,
              isShow: true,
              isSepaLine: false,
              list: [
                {
                  createTime: "2024-07-27 14:15:11",
                  updateTime: "2024-07-27 14:15:11",
                  creator: "太阳",
                  updateBy: "",
                  isDel: false,
                  id: 168,
                  parentId: 167,
                  name: "要货计划单",
                  abbrName: "",
                  icon: "",
                  url: "/plm/list",
                  perms: "",
                  type: 1,
                  orderNum: 0,
                  isShow: true,
                  isSepaLine: false,
                  isAdmin: 0
                },
                {
                  createTime: "2024-07-27 14:15:32",
                  updateTime: "2024-07-27 14:15:32",
                  creator: "太阳",
                  updateBy: "",
                  isDel: false,
                  id: 169,
                  parentId: 167,
                  name: "渠道库存报表",
                  abbrName: "",
                  icon: "",
                  url: "/plm/inventoryledger",
                  perms: "",
                  type: 1,
                  orderNum: 0,
                  isShow: true,
                  isSepaLine: false,
                  isAdmin: 0
                }
              ],
              isAdmin: 0
            }
          ],
          isAdmin: 0
        }
      ],
      menuTopDisplayed: true,
      showSettingModal: true,
      menuPopUpMethod: "MOUSE_CLICK"
    }
  },
  computed: {
    ...mapState("user", ["routes", "favoriteMenus", "userInfo"]),
    inTest() {
      if (location.origin.indexOf("localhost") > -1 || location.origin.indexOf("test") > -1) {
        return true
      }
      return false
    }
  },
  created() {
    this.outClick()
    this.getStaffInfo()
    this.getUserGeneralSettingsFind()
  },
  mounted() {
    this.appendDomToRoot(document.querySelector("#settingModal"))
  },
  beforeDestroy() {},
  methods: {
    onMousedownHeader() {
      if (this.menuPopUpMethod === "MOUSE_CLICK") return
      this.$store.commit("user/SET_NOWSYS", "")
    },
    changeHeaderImage(imgUrl) {
      this.imgSrc = imgUrl || defaultImgNew
    },
    async getStaffInfo() {
      const { code, data } = await apiStaffGetStaffInfo()
      if (code != 0) return
      this.changeHeaderImage(data.staffImage)
    },
    appendDomToRoot(el, selector) {
      // el 为要操作的dom元素，selector为要插入的根节点的选择器，为空的话，直接插入到body中
      let container
      if (selector) {
        container = document.querySelector(selector)
      }
      if (!container) {
        container = document.body
      }
      container.appendChild(el)
    },
    cancelSettingModal() {
      this.showSettingModal = false
      this.showGropdownStatus = false
    },
    // 获取通用设置
    async getUserGeneralSettingsFind() {
      const { code, data = {} } = await apiUserGeneralSettingsFind()
      if (code != 0) return
      this.menuTopDisplayed = data.menuTopDisplayed ?? localStorage.getItem("favTopShow") == "true"
      this.menuPopUpMethod = data.menuPopUpMethod || "MOUSE_CLICK"
      if (localStorage.getItem("favTopShow") == null) {
        if (this.menuTopDisplayed) {
          this.$store.commit("tagsView/CHANGE_FAVTOPSHOW", "true")
        } else {
          this.$store.commit("tagsView/CHANGE_FAVTOPSHOW", "")
        }
        this.$router.go(0)
      }
    },
    // 拼接收藏菜单
    newFavoriteMenus() {
      const obj = {
        name: "常用菜单",
        id: -999,
        abbrName: "常用",
        icon: "http://tf-scrm-test.oss-cn-shenzhen.aliyuncs.com/src/menu/menuIcon_790ef295-0dff-4f32-8cfb-6c0c365e2bc6_1722236140410.png",
        list: this.favoriteMenus
      }
      return obj
    },
    // 点击非菜单区域，关闭二层菜单
    outClick() {
      document.addEventListener("click", e => {
        if (this.$refs.sidebar) {
          const self = this.$refs.sidebar.contains(e.target)
          if (!self) {
            // 重制nowSys,让二层菜单隐藏
            // this.$store.commit("user/SET_NOWSYS", "")
          } else {
            // 二层菜单，当点击自己时，也隐藏，保证在小屏幕小，可以关闭
            // this.$store.commit("user/SET_NOWSYS", "")
          }
        }
      })
    },
    openSetting() {
      this.showSettingModal = true
      this.$nextTick(() => {
        this.$refs.settingModal.show()
      })
    },
    async logout() {
      await this.$store.dispatch("user/logout")
      // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      // this.$router.push(`/login`)
      // 刷新页面, 下次进入页面重新加载接口
      window.location.href = "/"
    },
    lookComponents() {
      let url
      if (process.env.VUE_APP_ENV === "local") {
        url = "http://localhost:9529" + "/?ct_sso=" + this.getCookie("_token")
      } else {
        url = "https://page-ct-ui-test.tfeimall.com" + "/?ct_sso=" + this.getCookie("_token")
      }
      window.open(url)
    },
    getCookie(cname) {
      const name = cname + "="
      const ca = document.cookie.split(";")
      for (let i = 0; i < ca.length; i++) {
        var c = ca[i].trim()
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length)
      }
      return ""
    },
    resetPsw() {
      this.$router.push({ name: "resetPsw" })
    },
    // 点击下拉事件
    showGropdown() {
      this.showGropdownStatus = !this.showGropdownStatus
    },
    showBigImgSrc(imgUrl) {
      this.$viewerApi({
        images: [imgUrl]
      })
    }
  }
}
</script>
<style scoped lang="scss">
.sidebar {
  background-color: #132547;
  /* 背景色 */
  width: 200px;
  /* 初始宽度 */
  color: #ffffff;
  /* 文字颜色 */
  transition: width 0.1s ease;
  /* 过渡效果 */
  position: fixed;
  height: 100vh;
  z-index: 20001;
}

.sidebar .menu-items {
  padding: 10px 0;

  .user-name {
    font-size: 12px;
    margin: 0 0 5px 0;
    text-align: center;
  }
}

.avatar {
  width: 33px;
  height: 33px;
  overflow: hidden;
  border-radius: 5px;
  margin: 0 auto;
  margin-bottom: 8px;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
  }
}

.avatar-container {
  margin-left: 10px;
}

.userInfo {
  display: flex;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 1px solid #e7e9ec;

  > img {
    width: 32px;
    height: 32px;
  }

  .userInfo-right {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 32px;
    margin-left: 8px;
  }

  .username {
    font-weight: bold;
    font-size: 14px;
    color: #333333;
    line-height: 14px;
    margin-bottom: 4px;
  }

  .company {
    font-size: 12px;
    color: #999999;
    line-height: 12px;
  }
}

::v-deep .el-dropdown-menu__item {
  padding: 0 16px;
}

::v-deep .popper__arrow {
  display: none !important;
}

.user-dropdown ::v-deep .el-dropdown-menu__item.is-disabled {
  pointer-events: all !important;
}
</style>
<style lang="scss">
.user-dropdown {
  top: 15px !important;
  left: 25px !important;
  z-index: 20002 !important;
}

.dropdown_bg {
  position: fixed;
  width: calc(100vw);
  height: 100vh;
  z-index: 1999;
  left: 0;
  top: 0;
  opacity: 0;
}
</style>
